"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
require("./styles.scss");
var _reactJsPagination = _interopRequireDefault(require("react-js-pagination"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function PagesController(props) {
  var pageSize = props.pageSize,
    totalElements = props.totalElements,
    rangeDisplay = props.rangeDisplay,
    linkClass = props.linkClass,
    itemClass = props.itemClass,
    activeLinkClass = props.activeLinkClass;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "wm-sv-pages-container"
  }, /*#__PURE__*/_react.default.createElement(_reactJsPagination.default, {
    activePage: props.page + 1,
    totalItemsCount: totalElements,
    onChange: function onChange(num) {
      props.onPageChange(num - 1);
    },
    pageRangeDisplayed: rangeDisplay,
    linkClass: 'wm-standard-link ' + linkClass,
    itemClass: 'wm-standard-item ' + itemClass,
    itemsCountPerPage: pageSize,
    activeLinkClass: 'wm-standard-active-link ' + activeLinkClass
  }));
}
var _default = exports.default = PagesController;